import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Gardeningetc: Site = {
  id: 'gardeningetc',
  logo: 'svg/gardeningetc.svg',
  label: 'Gardeningetc',
  analyticsName: 'gardeningetc',
  hostname: 'gardeningetc.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
